import { AppAuthConfig } from '@nk/auth-lib';
import { AppEnvConfig } from '@nk/utils-lib';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const environment: AppEnvConfig = {
  production: true,
  cacheBusterTimestamp: new Date().getTime(),
  environmentKey: 'test',
  apiRootUrls: null,
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const appAuthConfig: AppAuthConfig = {
  domain: 'auth0.enin.ai',
  clientId: 'VY3KCAQ3s9K3WX4jJberGPxNdSreyBSl',
  responseType: 'token id_token',
  audience: 'https://risk.enin.ai/api',
  scope: 'openid profile email read:user',
};
